import {
  buildTimeIntervalDimensionsConfig,
  buildTimeIntervalDimensionsGrouping,
  createSchemaConfig,
} from '../helpers/schema.helpers'
import { FormatterType } from '../types/formatter.types'
import { InsightsMetricDesiredDirection } from '../types/schema.types'
import { Dimensions, Metrics } from './insightsPortalFlyers.types'

export { Metrics, Dimensions }

export const schemaConfig = createSchemaConfig({
  metrics: Metrics,
  dimensions: Dimensions,
  metricsConfig: {
    [Metrics.ATTRIBUTED_SALES]: {
      label: 'insightsPortalDomain.flyers.metrics.attributedSales',
      formatter: FormatterType.Currency,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.attributedSales.tooltip',
    },
    [Metrics.ATTRIBUTED_ERV]: {
      label: 'insightsPortalDomain.flyers.metrics.attributedErv',
      formatter: FormatterType.Currency,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.attributedErv.tooltip',
    },
    [Metrics.ATTRIBUTED_UNITS_SOLD]: {
      label: 'insightsPortalDomain.flyers.metrics.attributedUnitsSold',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.attributedUnitsSold.tooltip',
    },
    [Metrics.ORDER_COUNT]: {
      label: 'insightsPortalDomain.flyers.metrics.orderCount',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.orderCount.tooltip',
    },
    [Metrics.AVG_GMV]: {
      label: 'insightsPortalDomain.flyers.metrics.avgGmv',
      formatter: FormatterType.Currency,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.avgGmv.tooltip',
    },
    [Metrics.AVG_ORDERED_ITEM]: {
      label: 'insightsPortalDomain.flyers.metrics.avgOrderedItem',
      formatter: FormatterType.Decimal,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.avgOrderedItem.tooltip',
    },
    [Metrics.NUM_DISTINCT_FLYERS]: {
      label: 'insightsPortalDomain.flyers.metrics.numDistinctFlyers',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.numDistinctFlyers.tooltip',
    },
    [Metrics.GROSS_IMPRESSIONS]: {
      label: 'insightsPortalDomain.flyers.metrics.grossImpressions',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.grossImpressions.tooltip',
    },
    [Metrics.VISIT_IMPRESSIONS]: {
      label: 'insightsPortalDomain.flyers.metrics.visitImpressions',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.visitImpressions.tooltip',
    },
    [Metrics.USER_IMPRESSIONS]: {
      label: 'insightsPortalDomain.flyers.metrics.userImpressions',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.userImpressions.tooltip',
    },
    [Metrics.GROSS_ADD_TO_CARTS]: {
      label: 'insightsPortalDomain.flyers.metrics.grossAddToCarts',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.grossAddToCarts.tooltip',
    },
    [Metrics.VISIT_ADD_TO_CARTS]: {
      label: 'insightsPortalDomain.flyers.metrics.visitAddToCarts',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.visitAddToCarts.tooltip',
    },
    [Metrics.USER_ADD_TO_CARTS]: {
      label: 'insightsPortalDomain.flyers.metrics.userAddToCarts',
      formatter: FormatterType.Integer,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.userAddToCarts.tooltip',
    },
    [Metrics.GROSS_CLICK_THROUGH_RATE]: {
      label: 'insightsPortalDomain.flyers.metrics.grossClickThroughRate',
      formatter: FormatterType.Percentage,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.grossClickThroughRate.tooltip',
    },
    [Metrics.VISIT_CLICK_THROUGH_RATE]: {
      label: 'insightsPortalDomain.flyers.metrics.visitClickThroughRate',
      formatter: FormatterType.Percentage,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.visitClickThroughRate.tooltip',
    },
    [Metrics.USER_CLICK_THROUGH_RATE]: {
      label: 'insightsPortalDomain.flyers.metrics.userClickThroughRate',
      formatter: FormatterType.Percentage,
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
      tooltip: 'insightsPortalDomain.flyers.metrics.userClickThroughRate.tooltip',
    },
    [Metrics.LAST_ETL_UPDATE]: {
      private: true,
      formatter: FormatterType.Date,
    },
  },
  dimensionGroupings: [
    buildTimeIntervalDimensionsGrouping,
    {
      label: 'insightsPortalDomain.filters.stores',
      dimensions: [
        Dimensions.WAREHOUSE,
        Dimensions.WAREHOUSE_LOCATION,
        Dimensions.WAREHOUSE_LOCATION_CODE,
        Dimensions.WAREHOUSE_LOCATION_GROUP,
        Dimensions.WAREHOUSE_LOCATION_STATE,
        Dimensions.STORE_REGION,
      ],
    },
    {
      label: 'insightsPortalDomain.filters.platform.label',
      dimensions: [Dimensions.PLATFORM],
    },
    {
      label: 'insightsPortalDomain.flyers.filters.flyers',
      dimensions: [
        Dimensions.FLYER_ID,
        Dimensions.FLYER_NAME,
        Dimensions.PARTNER,
        Dimensions.FLYER_TAG,
      ],
    },
  ],
  dimensionsConfig: {
    [Dimensions.FLYER_ID]: {
      label: 'insightsPortalDomain.flyers.dimensions.flyerId',
    },
    [Dimensions.FLYER_NAME]: {
      label: 'insightsPortalDomain.flyers.dimensions.flyerName',
    },
    [Dimensions.FLYER_TAG]: {
      label: 'insightsPortalDomain.flyers.dimensions.flyerTag',
    },
    [Dimensions.PARTNER]: {
      label: 'insightsPortalDomain.filters.retailer',
    },
    [Dimensions.WAREHOUSE]: {
      label: 'insightsPortalDomain.filters.banners.label',
    },
    [Dimensions.WAREHOUSE_LOCATION]: {
      label: 'insightsPortalDomain.filters.storeLocation.label',
    },
    [Dimensions.WAREHOUSE_LOCATION_CODE]: {
      label: 'insightsPortalDomain.filters.storeLocationCode.label',
    },
    [Dimensions.WAREHOUSE_LOCATION_GROUP]: {
      label: 'insightsPortalDomain.filters.storeGroup.label',
    },
    [Dimensions.WAREHOUSE_LOCATION_STATE]: {
      label: 'insightsPortalDomain.filters.state.label',
    },
    [Dimensions.PLATFORM]: {
      label: 'insightsPortalDomain.filters.platform.label',
    },
    [Dimensions.STORE_REGION]: {
      label: 'insightsPortalDomain.filters.region.label',
    },
    ...buildTimeIntervalDimensionsConfig,
  },
})
